<script lang="ts">
	import ArticlePager from '$lib/components/ArticlePager.svelte';
	import { formatDateLong } from '$lib/utils/dates';
	import { page } from '$app/stores';

	export let data;

	$: site = $page.data.site;
	$: post = data.post;
	$: canonical = `${site.urls.blog}/posts/${post.slug}`;
</script>

<svelte:head>
	<title>{post.title} | {site.name}</title>
	<meta name="description" content={post.excerpt} />
	<meta property="og:title" content={post.title} />
	<meta property="og:description" content={post.excerpt} />
	<meta property="og:type" content="article" />
	<meta property="og:url" content={canonical} />
	{#if post.date}
		<meta property="article:published_time" content={post.date} />
	{/if}
	<meta property="article:author" content={site.name} />
	<link rel="canonical" href={canonical} />
</svelte:head>

<main id="main" class="article-page">
	<article class="article">
		<div class="container article-wrap">
			<nav class="article-crumb" aria-label="Breadcrumb">
				<a href="/#archive">All notes</a>
			</nav>

			<header class="article-header">
				<p class="article-dateline">
					{#if post.date}
						<time datetime={post.date}>{formatDateLong(post.date)}</time>
						<span class="meta-sep" aria-hidden="true">·</span>
					{/if}
					<span>{post.readingMinutes} min read</span>
					<span class="meta-sep" aria-hidden="true">·</span>
					<span class="article-byline">{site.name}</span>
				</p>
				<h1>{post.title}</h1>
				{#if post.excerpt}
					<p class="article-dek">{post.excerpt}</p>
				{/if}
			</header>

			<div class="article-body markdown-content">
				{@html post.html}
			</div>
		</div>
	</article>

	<div class="container article-wrap">
		<ArticlePager older={data.older} newer={data.newer} />
	</div>
</main>
